/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, theme } from "@nordcloud/gnui";
import { ROUTES } from "~/routing/routes";
import { useTopSummaryData } from "../../hooks";
import { StatusChartItem } from "../types";
import { StatItem } from "./StatItem";
import { StatusCard } from "./StatusCard";
import {
  HorizontalDivider,
  StatSummaryContainer,
  TopSummaryWidgetContainer,
} from "./styles";

type Props = {
  resourcesStatus: StatusChartItem[];
  resourcesTotal: number | undefined;
  resourcesLoading: boolean;
};

export function TopSummaryWidget({
  resourcesStatus,
  resourcesTotal,
  resourcesLoading,
}: Props) {
  const {
    usersCount,
    plansCount,
    averageMonthlyEvents,
    usersLoading,
    plansLoading,
    eventsLoading,
    accountsStatus,
    accountsCount,
    accountsLoading,
  } = useTopSummaryData();

  return (
    <TopSummaryWidgetContainer>
      <StatSummaryContainer boxStyle="lightGrey">
        <FlexContainer
          justifyContent="space-between"
          alignItems="center"
          gap={theme.spacing.spacing06}
        >
          <StatItem
            icon="user"
            label="Users"
            count={usersCount}
            link={ROUTES.permissions.users}
            loading={usersLoading}
          />
          <StatItem
            icon="production"
            label="Plans"
            count={plansCount}
            link={ROUTES.plans.index}
            loading={plansLoading}
          />
        </FlexContainer>
        <HorizontalDivider />
        <StatItem
          icon="production"
          label="Average Monthly Events"
          count={averageMonthlyEvents}
          loading={eventsLoading}
        />
      </StatSummaryContainer>
      <StatusCard
        icon="cloud"
        label="Cloud Accounts"
        items={accountsStatus}
        count={accountsCount}
        link={ROUTES.accounts.index}
        loading={accountsLoading}
      />
      <StatusCard
        icon="machineSettings"
        label="Resources"
        items={resourcesStatus}
        count={resourcesTotal}
        link={ROUTES.resources.index}
        loading={resourcesLoading}
      />
    </TopSummaryWidgetContainer>
  );
}
